export const GET_MENU_LIST_REQUEST = 'GET_MENU_LIST_REQUEST'
export const GET_MENU_LIST_SUCCESS = 'GET_MENU_LIST_SUCCESS'
export const GET_MENU_LIST_FAILED = 'GET_MENU_LIST_FAILED'
